export interface BrickPackPurchase {
  timestamp: string;
  totalPacks: number;
  brickContents: Map<string, number>; // brickId, amount
}

export const loadBrickPackPurchaseHistory = () => {
  let brickPackHistory: Map<string, BrickPackPurchase[]> = new Map<
    string,
    BrickPackPurchase[]
  >([]);

  //
  // TODO: Values are updated with data present in JSON save
  // Leaving as default values for now
  //

  // TODO: Dynamic add all brickpacks or at least ensure they are all hardcoded
  brickPackHistory.set("brickpack_sloped_bricks_part_one", []);
  brickPackHistory.set("brickpack_minifig_utensils_part_one", []);
  brickPackHistory.set("brickpack_bionicles_part_one", []);
  brickPackHistory.set("brickpack_animals_part_one", []);
  brickPackHistory.set("brickpack_minifig_utensils_part_two", []);
  brickPackHistory.set("brickpack_bionicles_part_two", []);
  brickPackHistory.set("brickpack_circular_bricks", []);
  brickPackHistory.set("brickpack_minifig_hair", []);
  brickPackHistory.set("brickpack_technic_bricks", []);
  brickPackHistory.set("brickpack_minifig_headgear", []);

  return brickPackHistory;
};

export const loadBrickPackStats = () => {
  let brickPackStats: Map<string, number> = new Map<string, number>([]);

  //
  // TODO: Values are updated with data present in JSON save
  // Leaving as default values for now
  //

  // TODO: Dynamic add all brickpacks or at least ensure they are all hardcoded
  brickPackStats.set("brickpack_sloped_bricks_part_one", 0);
  brickPackStats.set("brickpack_minifig_utensils_part_one", 0);
  brickPackStats.set("brickpack_bionicles_part_one", 0);
  brickPackStats.set("brickpack_animals_part_one", 0);
  brickPackStats.set("brickpack_minifig_utensils_part_two", 0);
  brickPackStats.set("brickpack_bionicles_part_two", 0);
  brickPackStats.set("brickpack_circular_bricks", 0);
  brickPackStats.set("brickpack_minifig_hair", 0);
  brickPackStats.set("brickpack_technic_bricks", 0);
  brickPackStats.set("brickpack_minifig_headgear", 0);

  return brickPackStats;
};

export const loadBrickPackUpgrades = () => {
  let brickPackUpgrades: Map<string, number> = new Map<string, number>([]);

  //
  // TODO: Values are updated with data present in JSON save
  // Leaving as default values for now
  //

  // TODO: Dynamic add all brickpacks or at least ensure they are all hardcoded
  brickPackUpgrades.set("brickpack_sloped_bricks_part_one", 0);
  brickPackUpgrades.set("brickpack_minifig_utensils_part_one", 0);
  brickPackUpgrades.set("brickpack_bionicles_part_one", 0);
  brickPackUpgrades.set("brickpack_animals_part_one", 0);
  brickPackUpgrades.set("brickpack_minifig_utensils_part_two", 0);
  brickPackUpgrades.set("brickpack_bionicles_part_two", 0);
  brickPackUpgrades.set("brickpack_circular_bricks", 0);
  brickPackUpgrades.set("brickpack_minifig_hair", 0);
  brickPackUpgrades.set("brickpack_technic_bricks", 0);
  brickPackUpgrades.set("brickpack_minifig_headgear", 0);

  return brickPackUpgrades;
};
